<template>
  <v-container>
    <h4>Job Information</h4>
    <v-row>
      <v-col cols="12">
        <div>
          <header>Job role</header>
          <v-row>
            <v-col v-for="(item, i) in job_list" :key="i" cols="6" md="3">
              <v-checkbox v-model="job_information.job_roles" :value="item.value" :label="item.label" />
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="12" md="4">
        <v-switch v-model="job_information.active" label="Available" inset color="orange"></v-switch>
      </v-col>
      <v-col cols="12" md="4">
        <v-select :items="job_live_list" item-text="label" item-value="value" label="Job live-in/live-out"
          v-model="job_information.job_live" outlined dense></v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-select :items="job_type_list" item-text="label" item-value="value" label="Job type"
          v-model="job_information.job_type" outlined dense></v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-select :items="job_location_list" item-text="label" item-value="value" label="Job location"
          v-model="job_information.job_location" outlined dense></v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-select :items="location_list" item-text="label" item-value="value" label="Job request area"
          v-model="job_information.job_request_area" outlined dense></v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field v-model="job_information.expected_salary" label="Expected salary" outlined dense />
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox v-model="job_information.is_pet" label="Ok with pet" />
      </v-col>
      <v-col cols="12" md="6">
        <v-select v-if="job_information.is_pet" :items="pet_detail_list" item-text="label" item-value="value"
          label="Pet preference" v-model="job_information.pet_detail" outlined dense></v-select>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox v-model="job_information.is_app" label="Accept application job" />
      </v-col>
      <v-col cols="12" md="6">
        <v-select v-if="job_information.is_app" :items="app_available_time_list" item-text="label" item-value="value"
          label="Available time" v-model="job_information.app_available_time" outlined dense></v-select>
      </v-col>
      <v-col cols="12">
        <div v-if="job_information.is_app">
          <header>Available Day(s)</header>
          <v-row>
            <v-col v-for="(item, i) in day_list" :key="i" cols="6" md="3">
              <v-checkbox v-model="job_information.app_available_days" :value="item.value" :label="item.label" />
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <v-textarea v-model="job_information.remark" label="Remark" outlined dense height="80"></v-textarea>
      </v-col>
      <v-col cols="12" md="6">
        <v-textarea v-model="job_information.comment" label="Comment" outlined dense height="80"></v-textarea>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="job_information.reference_person" label="Reference person" outlined dense />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field v-model="job_information.reference_contact" label="Reference contact" outlined dense />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import location_list from "../../../json/location_list.json";
import jobRoles from "../job-roles.json";
export default {
  name: "JobInformation",
  components: {},
  props: ["job_information"],
  data: () => ({
    job_list: jobRoles,
    job_live_list: [
      { label: "Live-in", value: "Live in" },
      { label: "Live-out", value: "Live out" },
      { label: "Live-in-and-out", value: "Live in and out" },
    ],
    job_type_list: [
      { label: "Full-time", value: "Full time" },
      { label: "Part-time", value: "Part time" },
      { label: "Full-time or Part-time", value: "Full time or Part time" },
    ],
    job_location_list: [
      { label: "Bangkok", value: "Bangkok" },
      { label: "Nonthaburi", value: "Nonthaburi" },
      { label: "Phnom Penh, Cambodia", value: "Cambodia" },
      { label: "Vientiane, Laos", value: "Laos" },
      { label: "Phuket", value: "Phuket" },
      { label: "Pattaya", value: "Pattaya" },
      { label: "Chiang Mai", value: "Chiang Mai" }
      // { label: "Minburi", value: "Minburi" },
      // { label: "Samut Prakan", value: "Samut Prakan" },
      // { label: "Samut Sakhon", value: "Samut Sakhon" },
      // { label: "Pathum Thani", value: "Pathum Thani" },
      // { label: "Rang Sit", value: "Rang Sit" },
      // { label: "Nakhon Pathom", value: "Nakhon Pathom" },
      // { label: "Phutthamonthon", value: "Phutthamonthon" },
    ],
    location_list: location_list,
    pet_detail_list: [
      { label: "-", value: null },
      { label: "Ok with cat and dog", value: "Ok with cat and dog" },
      { label: "Ok with cat but dog", value: "Ok with cat but dog" },
      { label: "Ok with dog but cat", value: "Ok with dog but cat" },
    ],
    day_list: [
      { label: "Monday", value: "Mon" },
      { label: "Tuesday", value: "Tue" },
      { label: "Wednesday", value: "Wed" },
      { label: "Thursday", value: "Thu" },
      { label: "Friday", value: "Fri" },
      { label: "Saturday", value: "Sat" },
      { label: "Sunday", value: "Sun" },
    ],
    app_available_time_list: [
      { label: "Full day", value: "Full day" },
      { label: "Morning", value: "Morning" },
      { label: "Afternoon", value: "Afternoon" },
    ],
    rules: {
      require: (value) => !!value || "Please fill in information",
      email: (eml) => !eml || /.+@.+\..+/.test(eml) || "E-mail must be valid",
    },
  }),
  methods: {
    updateJobRole(label, value) {
      console.log(label + value);
      if (value) {
        this.job.push(label);
      }
    },
  },
};
</script>

<style scoped></style>